import { useQuery } from '@tanstack/react-query';
import { Endpoints } from '@xver/apis';
import type { AuthorizationResponse } from '@xver/apis/v1/kufer/github/model';

export const GITHUB_AUTHORIZATION_QUERY_KEY = ['apis.v1.kufer.github.authorization'];

export function useGitHubAuthQuery() {
    return useQuery<AuthorizationResponse>({
        queryKey: GITHUB_AUTHORIZATION_QUERY_KEY,
        queryFn: Endpoints.v1.Kufer.GitHub.getAuthorization,
        retry: false,
        staleTime: 30_000,
    });
}
